'use client'

import { ImageWithCustomLoader as ImageWithCustomLoaderDC, CustomImageProps } from 'design-configuration/components'

// We occasionally manually upload assets directly to Cloudinary under the
// "https://res.cloudinary.com/art-blocks/..." namespace. Because our Cloudinary
// account's `Allowed fetch domains` list does *not* include `res.cloudinary.com`,
// routing those URLs back through our custom `cloudinaryLoader` (which relies on
// Cloudinary's `image/fetch`) would 400-out.
//
// Instead we deliberately fall back to the *default* Next.js remote loader when
// the source already sits on Cloudinary.  That path is still optimised by
// Next.js (resize, AVIF/WebP, caching, etc.) because our `next.config.js` grants
// permission for `res.cloudinary.com` *only* within the `/art-blocks/**` path.
// This keeps the surface area of allowed remote images small while avoiding a
// second, unnecessary round-trip through Cloudinary's fetch pipeline.
const CLOUDINARY_BASE_URL = 'https://res.cloudinary.com'

export const ImageWithCustomLoader = ({ ...props }: CustomImageProps): React.ReactElement | null => {
  const getForceDefaultLoader = (): boolean => {
    if (props.forceDefaultLoader !== undefined) {
      return props.forceDefaultLoader
    }

    if (typeof props.src === 'string') {
      return props.src.startsWith(CLOUDINARY_BASE_URL)
    }

    return false
  }

  return <ImageWithCustomLoaderDC forceDefaultLoader={getForceDefaultLoader()} {...props} />
}
